import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as InstitutionActions from '../actions/Institution';
import InstitutionsList from '../components/InstitutionsList';
import { RootState } from '../store/configureStore';
import { Dispatch } from 'redux';

function mapStateToProps(state: RootState) {
  return {
    institution: state.institution,
    auth: state.auth,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    institutionActions: bindActionCreators(InstitutionActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstitutionsList);
